import { createQueryKeys } from '@lukemorales/query-key-factory';

import { SortingKey } from '../../../demand/components/SortingKey';
import { getDemandInformation } from '../clients/demand.api';

export const demandInformation = createQueryKeys('demandInformation', {
    byParams: (sortingKey: SortingKey, groupId?: string) => ({
        queryKey: [{ sortingKey, groupId }],
        queryFn: () => getDemandInformation(sortingKey, groupId),
    }),
});
